import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { SprintStatusLabel } from '../UI/SprintStatusLabel';

interface MoveSprintTaskToPlanningModal {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  confirmLoading: boolean;
}

export const MoveSprintTaskToPlanningModal = (props: MoveSprintTaskToPlanningModal) => {
  const { open, onCancel, onOk, confirmLoading } = props;
  return (
    <Modal
      okText="Complete Sprint"
      cancelText="Cancel"
      okType="primary"
      width={'580px'}
      open={open}
      title={
        <div className="flex">
          <SprintStatusLabel className="ml-2" sprintStatus={'sprint'} component={'table'} />
          <ArrowRightOutlined className="mx-2" />
          <SprintStatusLabel sprintStatus={'planning'} component={'table'} />
        </div>
      }
      styles={{ header: { marginLeft: '16px' }, body: { marginLeft: '16px' } }}
      onCancel={onCancel}
      onOk={onOk}
      onClose={onCancel}
      centered
      footer={
        <div className="flex flex-row justify-between items-center">
          <div></div>
          <div className="ml-auto">
            <Button className="py-[5px]" key="back" onClick={onCancel}>
              Cancel
            </Button>
            <Button className="ml-3 py-[5px]" key="submit" type="primary" onClick={onOk}>
              Move to Planning
            </Button>
          </div>
        </div>
      }
    >
      <div className="mt-6">
        This task seems to already be in the current sprint. Do you wish to remove it from Sprint and add it to Planning
        instead?
      </div>
      <div className="h-8"></div>
    </Modal>
  );
};
